<template>
  <el-dialog
    title="个人设置"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="beforeCloseHandler"
  >
    <div></div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSave">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "settings",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    beforeCloseHandler(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleSave() {
      // TODO
      this.$message({
        type: "info",
        message: "保存成功",
      });
    },
    handleCancel() {
      this.$emit("update:dialogVisible", false);
    },
  },
};
</script>
<style></style>
